module.exports = __webpack_public_path__ + "static/media/browse-electric-vehicles.532deb2a.svg";